import { I18n } from '@calendly/i18n';
import { Header as CuiHeader } from '@calendly/ui/components/popup';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { CRM_SHAREABLE } from 'features/mfe_shareable';
import { FullStoryExclude, FullStoryMask } from '../../../shared/fullstory_privacy';
import { eventTypeSelector, inviteeSelector, isInviteeOnlyRescheduleSelector, flowKindSelector } from '../selectors';
import { FlowKind } from '../slice';
const markerCss = "mu5a1ee";
const Marker = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    color,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  const style = {
    backgroundColor: color
  };
  return <Component ref={ref} {...restProps} style={style} className={classNames(markerCss, props.className)} />;
});
const avatarLetterCss = "a15a6fel";
const AvatarLetter = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(avatarLetterCss, props.className)} />;
});
const EventTypeNameWithColor = ({
  eventType
}) => <>
    <Marker color={eventType?.color} />
    {' '}
    {eventType?.name}
  </>;
const InviteeNameWithAvatar = ({
  invitee
}) => <>
    <FullStoryExclude>
      <AvatarLetter>{invitee.name[0]}</AvatarLetter>
    </FullStoryExclude>
    {' '}
    <FullStoryMask>
      {invitee.name}
    </FullStoryMask>
  </>;
export const Header = ({
  source
}) => {
  const eventType = useSelector(eventTypeSelector);
  const invitee = useSelector(inviteeSelector);
  const flowKind = useSelector(flowKindSelector);
  const isInviteeOnlyReschedule = useSelector(isInviteeOnlyRescheduleSelector);
  if (flowKind === FlowKind.reschedule) {
    return <CuiHeader title={isInviteeOnlyReschedule ? I18n.t('publisher.rescheduling_flow.title_invitee') : I18n.t('publisher.rescheduling_flow.title')} subtitle={isInviteeOnlyReschedule ? <InviteeNameWithAvatar invitee={invitee} /> : <EventTypeNameWithColor eventType={eventType} />} />;
  }
  if (source === CRM_SHAREABLE) {
    return <CuiHeader title={I18n.t('publisher.contacts.buttons.send_email')} />;
  }
  return <CuiHeader title={`${I18n.t('publisher.booking_modal.sharing')} ${eventType?.name}`} subtitle={<EventTypeNameWithColor eventType={eventType} />} />;
};

require("./popup_header.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./popup_header.js");